import { render } from "./DiceRollerCanvas.vue?vue&type=template&id=f6c83756&scoped=true"
import script from "./DiceRollerCanvas.vue?vue&type=script&lang=js"
export * from "./DiceRollerCanvas.vue?vue&type=script&lang=js"

import "./DiceRollerCanvas.vue?vue&type=style&index=0&id=f6c83756&scoped=true&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6c83756"]])

export default __exports__